import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { ActionCardWebElement } from './ActionCardWebElement';
export { ActionCardWebElement };

/**
 * Retrieve an instance of [ActionCardWebElement](../classes/ActionCardWebElement.html).
 * @example
 * ```javascript
 * import { findActionCard } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findActionCard(driver, By.id('my-oj-c-action-card'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findActionCard(driver: DriverLike, by: By): Promise<ActionCardWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type ActionCardWebElement
  if (!(webEl instanceof ActionCardWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'ActionCardWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findActionCard(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${ActionCardWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-action-card', ActionCardWebElement);
